export const ORDER_BEHAVIOUR = {
  RESTAURANT: {
    DELIVERY_SCREEN: {
      playBuzzer: true,
      showPopup: true,
      blinkIcon: true,
    },
    NON_DELIVERY_SCREEN: {
      playBuzzer: true,
      showPopup: false,
      blinkIcon: true,
    },
  },
  GROCERY: {
    DELIVERY_SCREEN: {
      playBuzzer: true,
      showPopup: true,
      blinkIcon: true,
    },
    NON_DELIVERY_SCREEN: {
      playBuzzer: false,
      showPopup: false,
      blinkIcon: true,
    },
  },
};
